// src/components/CataloguePDFDocument.jsx

import React from "react";
import {
  Page,
  Text,
  View,
  Document,
  StyleSheet,
  Image,
  Link
} from "@react-pdf/renderer";
import { getImageUrl, getUrl_PDF } from "../../MIS/Global";
import { encrypt } from "../../MIS/encryption";

const styles = StyleSheet.create({
  page: {
    padding: 20,
    fontSize: 10,
    // fontFamily: "Helvetica",
  },

  /* ================= HEADER ================= */

  headerWrapper: {
    backgroundColor: "#e6f2ff",
    padding: 14,
    borderRadius: 6,
    marginBottom: 15,
    position: "relative",
  },

  companyName: {
    fontSize: 16,
    fontWeight: "bold",
    marginBottom: 4,
  },

  companyInfo: {
    fontSize: 10,
    marginBottom: 2,
  },

  /* 🔥 Badge top right */
  badge: {
    position: "absolute",
    top: 10,
    right: 12,
    backgroundColor: "#333",
    color: "#fff",    
    fontSize: 11,
    paddingVertical: 4,
    paddingHorizontal: 10,
    borderRadius: 20,
    fontWeight: "bold",
  },

  /* ================= CATEGORY HEADINGS ================= */

  categoryWrapper: {
    marginBottom: 15,
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "flex-end",
  },

  leftHeadingBlock: {
    flexDirection: "column",
  },

  mainHeading: {
    fontSize: 14,
    fontWeight: "bold",
  },

  subHeading: {
    fontSize: 12,
    marginTop: 2,
  },

  subSubHeading: {
    fontSize: 11,
    color: "gray",
  },

  /* ================= PRODUCT GRID ================= */

  productGrid: {
    flexDirection: "row",
    flexWrap: "wrap",
    justifyContent: "space-between",
  },

  productCard: {
    width: "48%",
    marginBottom: 20,
  },

  /* 🔥 No border, no shadow, transparent */
  productImage: {
    width: "100%",
    height: "auto",   // auto adjust
    objectFit: "contain",
  },

  productName: {
    marginTop: 6,
    fontSize: 9,
    textAlign: "center",
  },

  /* ================= REMARK ================= */

  remarkSection: {
    marginTop: 25,
    backgroundColor: "#f4f9ff",
    padding: 12,
    borderRadius: 6,
  },

  remarkText: {
    fontSize: 10,
  },

  footer: {
    position: "absolute",
    bottom: 12,
    left: 0,
    right: 0,
    textAlign: "center",
    fontSize: 8,
    color: "gray",
  },
});

const CataloguePDFDocument = ({
  company = {},
  products = [],
  mainHeading,
  subHeading,
  subSubHeading,
  remarks
}) => {
  const handle_navigate = (element) => {        
      return `${getUrl_PDF()}tbk/${encrypt(element?.id)}`    
  };
  return (
    <Document>
      <Page size="A4" style={styles.page} wrap>

        {/* ================= HEADER ================= */}
        <View style={styles.headerWrapper}>
          <Text style={styles.companyName}>
            {company?.companyName || "Company Name"}
          </Text>

          {company?.fullName && (
            <Text style={styles.companyInfo}>{company.fullName}</Text>
          )}

          {company?.contact && (
            <Text style={styles.companyInfo}>{company.contact}</Text>
          )}

          {(company?.building || company?.road) && (
              <Text style={styles.companyInfo}>
                {[company?.building, company?.road]
                  .filter(Boolean)
                  .join(" ")}
              </Text>
            )}

          <View style={styles.badge}>
            <Text>{products.length} Products</Text>
          </View>
        </View>

        {/* ================= CATEGORY HEADINGS ================= */}
        {(mainHeading || subHeading || subSubHeading) && (
          <View style={styles.categoryWrapper}>
            
            {/* Left side: main + sub */}
            <View style={styles.leftHeadingBlock}>
              {mainHeading && (
                <Text style={styles.mainHeading}>{mainHeading}</Text>
              )}
              {subHeading && (
                <Text style={styles.subHeading}>{subHeading}</Text>
              )}
            </View>

            {/* Right side: subSub */}
            {subSubHeading && (
              <Text style={styles.subSubHeading}>{subSubHeading}</Text>
            )}
          </View>
        )}

        {/* ================= PRODUCT GRID ================= */}
        <View style={styles.productGrid}>
          {products.map((item, index) => (
            <View
              style={styles.productCard}
              key={index}
              wrap={false}   // 🔥 important (prevents split)
            >
              <Link src={handle_navigate(item)}>
                <Image
                  style={styles.productImage}
                  src={getImageUrl(`${item?.img}`)}
                />
              </Link>

              {item?.name && (
                <Text style={styles.productName}>{item.name}</Text>
              )}
            </View>
          ))}
        </View>

        {/* ================= REMARK ================= */}
        {remarks && (
          <View style={styles.remarkSection}>
            <Text style={styles.remarkText}>{remarks}</Text>
          </View>
        )}

        <Text style={styles.footer}>
          Generated on {new Date().toLocaleString()}
        </Text>

      </Page>
    </Document>
  );
};

export default CataloguePDFDocument;
